/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntityDetails = require('../../entity-form/services/GetEntityDetails');
var GetEntityNameDetails = require('../services/GetEntityNameDetails');
var GetAllEntityOrganizationTypes = require('../../entity-form/services/GetAllEntityOrganizationTypes');

var EntityNameChangeView = require('../views/EntityNameChangeView');

module.exports = function(entityId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetEntityDetails(entityId), GetEntityNameDetails(entityId), GetAllEntityOrganizationTypes())
    .done(function(entityDetails, entityNameDetails, entityOrganizationTypes) {
      NavUtils.navigate('ext/nondep/entity/' + entityId + '/change-name');

      entityDetails.newEntityName = entityDetails.entityName;

      Scaffold.content.show(
        new EntityNameChangeView({
          isReadOnly: false,
          model: new Backbone.Model(_.extend({ entityId: entityId, entityOrganizationTypes: entityOrganizationTypes }, entityDetails, entityNameDetails))
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
